import { api } from "../Configurations/axios";

const createProjectWithGroupingAPI = async (projectIdList: string, groupingId: string, companyId: string) => {
    try {
        var result = await api.post('/ProjectWithGrouping/CreateProjectWithGrouping/', { projectIdList: projectIdList, groupingId: groupingId, companyId: companyId });
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const getAllPaginatedByGroupingIdAPI = async (groupingId: string, page: number, take: number, word: string) => {
    try {
        var result = await api.get(`/ProjectWithGrouping/GetAllPaginatedByGroupingId/groupingId=${groupingId}&page=${page}&take=${take}&word=${encodeURIComponent(word)}`);
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const getAllProjectsNotLinkedPaginatedByCompanyId = async (companyId: string, groupingId: string, year: number, page: number, take: number, word: string) => {
    try {
        var result = await api.get(`/ProjectWithGrouping/GetAllProjectsNotLinkedByCompanyId/companyId=${companyId}&groupingId=${groupingId}&year=${year}&page=${page}&take=${take}&word=${encodeURIComponent(word)}`);
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const deleteProjectFromGroupingByIdAPI = async (id: string, companyId: string, groupingId: string) => {
    try {
        var data = { id: id, companyId: companyId, groupingId: groupingId }
        var result = await api.delete('/ProjectWithGrouping/DeleteProjectFromGroupingById/', { data });
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

export {
    createProjectWithGroupingAPI,
    getAllPaginatedByGroupingIdAPI,
    getAllProjectsNotLinkedPaginatedByCompanyId,
    deleteProjectFromGroupingByIdAPI
}